'use client';

import {
  IcArrowDown,
  Menu,
  MenuContent,
  MenuItemContent,
  type MenuProps,
  MenuTrigger,
  Typography,
} from '@musinsa/mds';
import clsx from 'clsx';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';

export type CouponGoodsSort = 'POPULAR' | 'LOW_PRICE' | 'HIGH_PRICE' | 'SALE_THREE_MONTH_COUNT';

const SORT_OPTIONS: ReadonlyArray<{ value: CouponGoodsSort; label: string }> = [
  { value: 'POPULAR', label: '추천순' },
  { value: 'LOW_PRICE', label: '낮은가격순' },
  { value: 'HIGH_PRICE', label: '높은가격순' },
  { value: 'SALE_THREE_MONTH_COUNT', label: '판매수 많은순' },
];

interface CouponGoodsSortMenuProps {
  totalCount: number | undefined;
  selectedSort: CouponGoodsSort;
  onSelect: (sort: CouponGoodsSort) => void;
  className?: string;
}

const getLabel = (sort: CouponGoodsSort): string =>
  SORT_OPTIONS.find((option) => option.value === sort)?.label ?? '추천순';

export const CouponGoodsSortMenu = ({
  totalCount,
  selectedSort,
  onSelect,
  className,
}: CouponGoodsSortMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenChange: MenuProps['onOpenChange'] = (open) => {
    setIsOpen(open);
  };

  const handleSelect = (value: CouponGoodsSort) => {
    onSelect(value);
    setIsOpen(false);
  };

  return (
    <div
      className={twMerge(
        'flex items-center justify-between gap-5 bg-gray-100 px-4 py-3',
        className,
      )}
    >
      <Typography variant="body13pxReg" colorScheme="gray-600">
        {totalCount === undefined ? ' ' : `전체 ${totalCount.toLocaleString()}개`}
      </Typography>
      <Menu open={isOpen} onOpenChange={handleOpenChange}>
        <MenuTrigger>
          <Typography
            variant="body13pxReg"
            colorScheme="gray-600"
            className="inline-flex items-center gap-0.5"
            asChild
          >
            <button type="button" aria-haspopup="menu" aria-expanded={isOpen}>
              <span>{getLabel(selectedSort)}</span>
              <IcArrowDown
                width={12}
                height={12}
                strokeColor="gray-600"
                className={clsx(isOpen && 'rotate-180')}
              />
            </button>
          </Typography>
        </MenuTrigger>
        <MenuContent asChild>
          <ul className="w-[120px]">
            {SORT_OPTIONS.map((option) => (
              <MenuItemContent key={option.value} selected={selectedSort === option.value} asChild>
                <button
                  type="button"
                  className="w-full text-left"
                  onClick={() => handleSelect(option.value)}
                >
                  <li className="pr-2!">
                    <Typography lineClamp="one">{option.label}</Typography>
                  </li>
                </button>
              </MenuItemContent>
            ))}
          </ul>
        </MenuContent>
      </Menu>
    </div>
  );
};
